import { useLocation } from 'react-router';

import { useAuthDialog } from '@features/auth';
import { ROUTES } from '@shared/config/routes';
import { NextStepAction } from '@shared/ui';

import { useOwnerKind } from '../model/useServiceOffer';

interface PaymentStepActionProps {
  searchId: string;
  /** Подпись — строкой: она же уходит в полосу оболочки на телефоне. */
  children: string;
  className?: string | undefined;
}

/**
 * Переход к оплате — единственная красная кнопка экрана до оплаты (FE-586,
 * FE-587; DESIGN_SYSTEM §2.2, §5.1). Одна реализация для карточки следующего
 * шага на витрине и для выбора «Karl übernimmt» на экране автомобиля: правило
 * «вошедший — к оплате, гость — к входу» не должно разойтись между ними.
 *
 * Это переход, а не исполнение: на телефоне кнопку несёт полоса оболочки рядом
 * с Karl (FE-585), а в потоке она скрыта. Пока неизвестно, кто перед нами,
 * кнопки нет вовсе.
 */
export function PaymentStepAction({ searchId, children, className }: PaymentStepActionProps) {
  const location = useLocation();
  const { requestAuth } = useAuthDialog();
  const owner = useOwnerKind();

  if (owner === 'user') {
    return (
      <NextStepAction to={ROUTES.searchPayment(searchId)} className={className}>
        {children}
      </NextStepAction>
    );
  }
  if (owner === 'guest') {
    return (
      <NextStepAction
        className={className}
        onClick={() => {
          requestAuth({
            type: 'navigate',
            returnUrl: `${location.pathname}${location.search}`,
          });
        }}
      >
        {children}
      </NextStepAction>
    );
  }
  return null;
}
